import React, {useEffect} from "react";
import {useDispatch} from "react-redux";
import {css} from "@emotion/react";
import {BounceLoader, CenterBox} from "@web2/ui_utils";

import {logOut} from "../actions/logout";

export const LogoutView = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(logOut());
    }, []);

    return (
        <CenterBox css={centerBoxHolder}>
            <BounceLoader />
        </CenterBox>
    );
};

const centerBoxHolder = css`
    height: 100vh;
`;
